import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { RestProviderService } from 'src/app/shared/services/rest-provider.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { ConfiguracionPlanBean } from 'src/app/_beans/ConfiguracionPlanBean';
import { ObjetivoBean } from 'src/app/_beans/ObjetivoBean';

@Component({
  selector: 'app-objetivo-dialog',
  templateUrl: './objetivo-dialog.component.html',
  styleUrls: ['./objetivo-dialog.component.scss']
})
export class ObjetivoDialogComponent implements OnInit {
  objetivoSelect: ObjetivoBean;
  titulo: string = "Agregar";
  objetivosMultiLevelList: any[] = [];
  constructor(
    public sharedService: SharedService,
    public constantes: ConstantesService,
    private restProvider: RestProviderService,
    public dialogRef: MatDialogRef<ObjetivoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ObjetivoBean,
  ) { }

  ngOnInit(): void {

    if (this.data.id) {
      let params = {
        data: {
          id: this.data.id
        }
      }
      this.restProvider.executeHttpMethod("/oc/bpi", params).subscribe((result: any) => {
        this.objetivoSelect = result.data;
        this.titulo = "Editar " + this.objetivoSelect.configuracionPlan.nombre;
      }, error => {
        console.error(error);
      });
    } else {
      if (this.data.abrirDesdeMenu) {
        if (this.data.configuracionPlan.nivel != 1)
          this.obtenerTodosLosObjetivosPorIDConfiguracionPlan(this.sharedService.planSession.listaConfiguracionPlan[0].id);
      } else {
        this.titulo = this.titulo.concat(" " + this.data.configuracionPlan.nombre);
      }
      this.objetivoSelect = new ObjetivoBean();
      this.objetivoSelect.configuracionPlan = new ConfiguracionPlanBean();
      this.objetivoSelect.configuracionPlan = this.data.configuracionPlan;
      this.objetivoSelect.publicado=this.constantes.NO_ESTA_PUBLICADO;
      if (this.data.objetivoPadre) {
        this.objetivoSelect.objetivoPadre = this.data.objetivoPadre;
      }
    }
  }

  public obtenerTodosLosObjetivosPorIDConfiguracionPlan(idConfPlan: number) {
    let params = {
      data: {
        configuracionPlan: {
          id: idConfPlan
        }
      }
    }
    this.sharedService.planSession.listaConfiguracionPlan.forEach(conf => {
      if (conf.nivel < this.data.configuracionPlan.nivel){
          conf.objetivos = [];
          this.objetivosMultiLevelList.push(conf);
      }
    })
    return new Promise((resolve, reject) => {
      this.restProvider.executeHttpMethod("/oc/lpicp", params).subscribe((result: any) => {
        if (this.data.abrirDesdeMenu) {
          this.objetivosMultiLevelList[0].objetivos = [];
          this.objetivosMultiLevelList[0].objetivos = result.datalist;
        } else
          this.sharedService.sendObjectList.next(result.datalist);
        resolve("success");
      });
    });
  }

  public seleccionarObjetivo(event: any, posicion: number) {
    if (event.value) {
      this.limpiarObjetivosList(posicion + 1);
      if (this.objetivosMultiLevelList.length - 1 != posicion)
        this.obtenerTodosLosObjetivosPorIDObjetivoPadre(event.value.id, event.value.configuracionPlan.nivel);
      else {
        this.objetivoSelect.objetivoPadre = new ObjetivoBean();
        this.objetivoSelect.objetivoPadre.id = event.value.id;
      }
    }
  }
  public limpiarObjetivosList(posicion: number) {
    for (let index = posicion; index < this.objetivosMultiLevelList.length; index++)
      this.objetivosMultiLevelList[index].objetivos = [];
  }

  public guardar() {
    let params = {
      data: this.objetivoSelect
    }
    this.restProvider.executeHttpMethod("/oc/g", params).subscribe((result: any) => {
      if (!this.data.abrirDesdeMenu && !this.data.modificarDesdeHeader) {
        this.cerrar(result.data);
      } else {
        if (this.data.modificarDesdeHeader) {
          if (this.sharedService.abrirSidebarObjetivos)
            this.sharedService.updateSidebarObjetivos.next("Update");
          result.data.modificarDesdeHeader = true;
          this.sharedService.updateObjetivo.next(result.data);
        } if (this.data.abrirDesdeMenu) {
          if (this.objetivoSelect.objetivoPadre) {
            this.restProvider.calcularAvanceDesdePrimerNivel(result.data).then(() => {
              if (this.sharedService.abrirSidebarObjetivos)
                this.sharedService.updateSidebarObjetivos.next("Update");
            });
          } else {
            if (this.sharedService.abrirSidebarObjetivos)
              this.sharedService.updateSidebarObjetivos.next("Update");
          }
          this.sharedService.showMessageInfo("Registrado con éxito");
        }
        this.cerrar(result.data);
      }
    }, error => {
      this.cerrar();
      console.error(error);
    });
  }

  public obtenerTodosLosObjetivosPorIDObjetivoPadre(id: number, nivel?: number) {
    let params = {
      data: {
        objetivoPadre: {
          id: id
        }
      }
    }
    this.restProvider.executeHttpMethod("/oc/lpiop", params).subscribe((result: any) => {
      if (this.data.abrirDesdeMenu) {
        this.objetivosMultiLevelList[nivel].objetivos = result.datalist;
      } else {
        this.sharedService.sendObjectList.next(result.datalist);
        this.cerrar();
      }
    }, error => {
      console.error(error);
    });
  }

  public cerrar(objetivo?: ObjetivoBean) {
    objetivo ? this.dialogRef.close(objetivo) : this.dialogRef.close();
  }

  public verificarCampos() {
    if (this.objetivoSelect.nombre && this.objetivoSelect.descripcion) {
      if (this.objetivoSelect.configuracionPlan.nivel > 1 && !this.objetivoSelect.objetivoPadre)
        return false;
      return true;
    }
  }
}
